import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import StrategyManagerForm from "./StrategyManagerForm";

export default function StrategyManagerPage() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <StrategyManagerForm />
    </DashboardLayout>
  );
}
